import React from 'react'
import { observer } from 'mobx-react'
import JobProgressionViewModel from '../JobProgressionViewModel'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function DraftInReviewProgressionProActions({
  vm,
}: Props) {
  return (
    <>
      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
})
